import { Component, inject, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { EPrescriptionMagistraliterTemplateObject } from '@libs/types/src/services/object-type/sukl/e-prescription-magistraliter-template.object';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import { TableColumn } from '../../../../../modules/shared/components/kit/table/table.types';
import { textColumn } from '../../../../../modules/shared/components/kit/table/table.fields';
import {
    FolderEPrescriptionMagistraliterTemplatesDialogStore,
} from './folder-e-prescription-magistraliter-templates-dialog.store';
import {
    folderEPrescriptionMagistraliterTemplateFrag,
    folderEPrescriptionMagistraliterTemplatesTableFrag,
} from './folder-e-prescription-magistraliter-templates-dialog.query';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { ConfirmBuilder } from '../../../../../modules/shared/service/confirm.builder';
import { successDeleted } from '../../../../../modules/content/content.error';

@Component({
    selector: 'app-folder-e-prescription-magistraliter-templates-dialog',
    templateUrl: 'folder-e-prescription-magistraliter-templates-dialog.component.html',
    styleUrls: ['folder-e-prescription-magistraliter-templates-dialog.component.scss'],
    providers: [FolderEPrescriptionMagistraliterTemplatesDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ActionButtonsComponent, TableComponent],
})
export class FolderEPrescriptionMagistraliterTemplatesDialogComponent extends BaseDialogComponent {

    protected readonly store = inject(FolderEPrescriptionMagistraliterTemplatesDialogStore);
    private readonly confirmBuilder = inject(ConfirmBuilder);

    private readonly table = viewChild<TableComponent>('templatesTable');

    protected readonly selectedTemplate = signal<EPrescriptionMagistraliterTemplateObject | null>(null);

    protected readonly columns: TableColumn[] = [
        textColumn('name'),
        { ...textColumn('form', false, false), dataKey: 'formName' },
        { ...textColumn('administrationRoute', false, false), dataKey: 'administrationRouteName' },
    ];

    protected selectionChanged(
        selection: EPrescriptionMagistraliterTemplateObject | EPrescriptionMagistraliterTemplateObject[] | null,
    ): void {
        this.selectedTemplate.set(Array.isArray(selection) ? selection[0] || null : selection);
    }

    protected async loadTemplate(): Promise<void> {
        const selected = this.selectedTemplate();
        if (!selected) return;
        const templates = await this.store.api.getEPrescriptionMagistraliterTemplates(
            FilterBuilder.filter({ id: selected.id }),
            folderEPrescriptionMagistraliterTemplateFrag,
        );
        this.dialogRef.close(templates.items[0]);
    }

    protected deleteTemplate(event: { item: EPrescriptionMagistraliterTemplateObject; event: Event }): void {
        this.confirmBuilder.confirmDelete(async () => {
            await this.store.api.deleteEPrescriptionMagistraliterTemplate({ id: event.item.id });
            this.selectedTemplate.set(null);
            successDeleted();
            this.table()?.reload();
        }, event);
    }

    protected readonly tableFrag = folderEPrescriptionMagistraliterTemplatesTableFrag;
}
